import { PriceStrategySnapWorkOrder } from '@snap-types/transforms/price-strategy/shared';
import { dec, ZERO } from '@snap-types/types/decimal';

import { QuoteBuilderRequirementType } from '../../types/state/requirement';

export function transformSnapRequirementToStoreState(
  requirement: PriceStrategySnapWorkOrder['snapOperations'][number]['snapRequirements'][number],
): { uuid: string; requirement: QuoteBuilderRequirementType } {
  return {
    uuid: requirement.uuid,
    requirement: {
      uuid: requirement.uuid,
      pieceNo: requirement.pieceNo,
      calcQty: requirement.calcQty ?? dec(1),
      qtyPer: requirement.qtyPer,
      qtyPerType: requirement.qtyPerType,
      fixedQty: requirement.fixedQty,
      usageUnitOfMeasure: requirement.usageUnitOfMeasure ?? null,

      unitMaterialCost: requirement.unitMaterialCost,
      unitLaborCost: requirement.unitLaborCost,
      unitBurdenCost: requirement.unitBurdenCost,
      unitServiceCost: requirement.unitServiceCost,
      fixedCost: requirement.fixedCost ?? ZERO,
      scrapPercent: requirement.scrapPercent,

      part: requirement.part
        ? {
            partId: requirement.part.partId,
            description: requirement.part.description ?? null,
          }
        : null,
    },
  };
}
